import React from 'react';
import { string } from 'prop-types';
import { contextPropTypes } from '../../../../../proptypes/shared';
import TrailPropType from '../../../../../proptypes/TrailPropType';
import styles from './styles/styles.module.scss';
import CardLocation from '../../../../../components/cards/CardLocation';
import { getTrailProfilePhotoUrl } from '../../../../../utils/trail_helpers';
import useImage from '../../../../../hooks/useImage';

const MiniTrailCard = ({ trail, context, className }) => {
  const [trailImage, updateImageUrl] = useImage(getTrailProfilePhotoUrl(trail, 'small'));

  return (
    <div className={`${styles.container} ${className}`}>
      <img onError={() => updateImageUrl()} className={styles.trailImage} src={trailImage} alt={trail.name} />
      <div className={styles.trailData}>
        <div className={styles.trailName}>{trail.name}</div>
        <CardLocation trail={trail} context={context} className={styles.trailLocation} />
      </div>
    </div>
  );
};

MiniTrailCard.propTypes = {
  trail: TrailPropType,
  context: contextPropTypes.isRequired,
  className: string
};

MiniTrailCard.defaultProps = {
  trail: {},
  className: ''
};

export default MiniTrailCard;
